<div class="back-btn exit-dialog" (click)="onBackButton()"></div>
<div id="gradient-back">
  <div
    id="tvMenu"
    #tvMenu
    class="menu tv-menu vertical-focusable-container"
    [ngClass]="{ expanded: menuActive }"
    data-right="page-container"
    (click)="focusIn()"
    (mouseenter)="mouseIn()"
    (mouseleave)="mouseOut()"
    (focusin)="focusIn()"
    (focusout)="focusOut($event)"
    (mousemove)="focusIn()"
  >
    <div *ngIf="menuActive; else appLogo">
      <button *ngIf="client == 'dtc'; else tveHeader" class="highlight-button menu__item focusable-element">
        {{ 'navbar.subscribeNow' | translate }}
      </button>
      <ng-template #tveHeader>
        <div [ngClass]="{ 'tv-menu-logos': tveImgSrc }">
          <div class="app-logo tve"></div>
          <div>
            <img class="tve-logo" [src]="tveImgSrc">
          </div>
        </div>
      </ng-template>
    </div>
    <ng-template #appLogo>
      <div [ngClass]="{ 'tv-menu-logos': tveImgSrc }">
        <div [ngClass]="[client, showButton ? 'focusable-element' : '']" class="app-logo"></div>
        <div *ngIf="client == 'tve'">
            <img class="tve-logo" [src]="tveImgSrc">
          </div>
      </div>
    </ng-template>
    <div
      *ngFor="let item of tabs; trackBy: trackById; let i = index"
      #menuTarget
      tabindex="0"
      class="menu__item focusable-element"
      [ngClass]="{ 'selected-item': !menuActive && activeTab === item.id, selected: activeTab === item.id }"
      (focus)="focusTab(item)"
      (mouseenter)="focusItem($event, i + relativeVerticalIndex)"
      (mouseleave)="blurActiveElement()"
      (click)="
        redirectTo(
          item.id === 'search' || item.id === 'myhub' || item.id === 'epg' || item.id === 'my-content' ? item.id : 'tab',
          $event,
          item
        )
      "
    >
      <app-icon [active]="menuActive && activeTab === item.id && activeTab !== focusedTab" [name]="item.icon"></app-icon>
      <a class="menu__item__expanded">
        {{ item.name | translate }}
      </a>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
